<template>
    <div class="container about-teacher">
        <div class="row">
            <div class="col-md-12">
                <div class="heading">
                    <h3> About Teacher </h3>
                </div>
            </div>
        </div>
        <div class="bio-info mb-4">
            <div class="row">
                <div class="col-md-3 col-lg-2">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="bio-image">
                                <div class="teacher-image">
                                    <img :src="teacherData.profile_photo" alt="image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 col-lg-10">
                    <div class="bio-content">
                        <div class="d-flex justify-content-between">
                            <h4>{{ teacherData.name }}</h4>
                            <h4> {{ teacherData.rating }}.0</h4>
                        </div>
<!--                       <p>{{ teacherData.description}}</p>-->
                       <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab animi aperiam aut consectetur cum debitis, dolorum expedita facilis hic molestiae nobis nostrum optio pariatur provident soluta veniam vitae. Aliquid aperiam asperiores harum ipsa mollitia pariatur quam, quibusdam saepe tenetur voluptates. Doloribus exercitationem incidunt iure non placeat suscipit tempora ut voluptatem.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { teacherApi } from "../../services/teacherApi";

    export default {
        name: "about-teacher",
        data() {
            return {
                teacherData: {}
            };
        },

        props: {
            teacherId: String
        },

        mounted() {
            teacherApi.getTeacherByTeacherId(this.teacherId).then(res => {
                this.teacherData = res.data;
            });
        }
    };
</script>

<style scoped></style>
